import { useEffect } from "react";

function App() {
  const targetUrl = process.env.REACT_APP_REDIRECT_URL;

  useEffect(() => {
    if (!targetUrl) {
      console.error("Missing REACT_APP_REDIRECT_URL environment variable.");
      return;
    }

    if (window.location.href !== targetUrl) {
      window.location.replace(targetUrl);
    }
  }, [targetUrl]);

  if (!targetUrl) {
    return <div>Link de redirecionamento não configurado.</div>;
  }

  return <div>Redirecionando...</div>;
}

export default App;
